import type { App } from 'vue'

import type { SystemModule } from '@/config/app/types'

import { getAppConfig } from '@/shared/lib/tenant'

/**
 * Проверяет, доступен ли модуль в конфигурации тенанта
 */
function isModuleEnabled(path: string, enabledModules: SystemModule[]): boolean {
  // Всегда разрешаем специальные роуты
  if (path === '/' || path === '/500' || path.includes('/auth') || path === '/privacy-policy') {
    return true
  }

  const pathSegment = path.split('/')[1] as SystemModule

  return enabledModules.includes(pathSegment)
}

/**
 * Guard для проверки доступности модуля в конфигурации тенанта
 * Возвращает '/' если модуль недоступен, иначе null
 */
export function createModuleGuard(app: App) {
  const config = getAppConfig(app)

  return (path: string): string | null => {
    if (!isModuleEnabled(path, config.enabledSystemModules)) {
      console.warn(`Module for route "${path}" is not enabled for this tenant`)
      return '/'
    }

    return null
  }
}
